<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n2">
                            <v-autocomplete
                                outlined
                                :label="this.$t('roleassignment.description')"
                                type="text"
                                ref="roleid"
                                :rules="[rules.required]"
                                v-model="formData.roleid"
                                dense
                                :items="workflowList"
                                @input="updateValue"
                                @change="changeWorkflow(formData.roleid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="3" sm="3" class="pb-n4 mt-n2">
                            <v-text-field
                                outlined
                                :label="this.$t('roleassignment.code')"
                                type="text"
                                v-model="formData.workflowrole"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="9" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.name')"
                                type="text"
                                ref="staffid"
                                :rules="[rules.required]"
                                v-model="formData.staffid"
                                dense
                                :items="staffDetailsList"
                                @input="updateValue"
                                @change="changeStaffIDandCompanyHandler(formData.staffid)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.no')"
                                type="text"
                                v-model="formData.staffno"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.company')"
                                type="text"
                                v-model="formData.staffcompany"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4">
                            <v-row>
                                <v-col cols="6" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('columns.startdate')"
                                        type="date"
                                        :rules="[rules.required]"
                                        v-model="formData.startdate"
                                        @input="updateValue"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="this.$t('columns.enddate')"
                                        type="date"
                                        :rules="[rules.required]"
                                        v-model="formData.enddate"
                                        @input="updateValue"
                                        dense
                                        class="v-input"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="9" class="pb-n4 mt-n7">
                            <v-autocomplete
                                outlined
                                :label="this.$t('roleassignment.roleownername')"
                                type="text"
                                ref="ownerstaffid"
                                :rules="[rules.required]"
                                v-model="formData.ownerstaffid"
                                dense
                                :items="staffDetailsList"
                                @input="updateValue"
                                @change="changeOwnerStaffIDandCompanyHandler(formData.ownerstaffid)"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('roleassignment.roleownerstaffno')"
                                type="text"
                                v-model="formData.ownerstaffno"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('roleassignment.roleownercompany')"
                                type="text"
                                v-model="formData.ownerstaffcompany"
                                readonly
                                dense
                                class="v-input"
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="9" class="pb-n4 mt-n7">
                            <v-text-field
                                outlined
                                :label="this.$t('columns.remark')" 
                                id="remarks"
                                type="text"
                                ref="remarks"
                                v-model="formData.remarks"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                </v-container>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:SavePressed="saveHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>
        </v-container>
    </div>
</template>

<script>

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {
            formData: {
                roleid: this.parentObject.data.roleid,
                staffid: this.parentObject.data.staffid,
                ownerstaffid: this.parentObject.data.ownerstaffid,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                remarks: this.parentObject.data.remarks,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
                workflowrole: this.parentObject.data.workflowrole,
                staffno: this.parentObject.data.staffno,
                staffcompany: this.parentObject.data.staffcompany,
                ownerstaffno: this.parentObject.data.ownerstaffno,
                ownerstaffcompany: this.parentObject.data.ownerstaffcompany,
            },

            rules: { required: value => !!value || this.$t('reportsparam.required') },

            workflowList: [],
            staffDetailsList: [],

            workflowFull: [],
            staffFull: [],

            errMsg: '',
            isErr: false,
        }
    },

    methods: {

        changeWorkflow(id) {
            let item = this.workflowFull.find((item) => item.id === id);
            this.formData.workflowrole = item.role;
        },

        //change staff id and company after selecting psnnid
        changeStaffIDandCompanyHandler(id) {
            let item = this.staffFull.find(item => item.id === id);
            this.formData.staffno = item.staffcode;
            this.formData.staffcompany = item.compnyname;
        },

        //change staff id and company after selecting psnnid
        changeOwnerStaffIDandCompanyHandler(id) {
            let item = this.staffFull.find(item => item.id === id);
            this.formData.ownerstaffno = item.staffcode;
            this.formData.ownerstaffcompany = item.compnyname;
        },
        
        //load workflow list view
        loadWorkflowListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/workflowrole/active/all' })
            .then((res) => {

                vm.workflowFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.workflowList.push({
                        text: res.data.rec[i].roledesc,
                        value: res.data.rec[i].id,
                    });
                }

                if (vm.formData.roleid) {
                    vm.changeWorkflow(vm.formData.roleid);
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        //load staffdetails list view
        loadStaffDetailsListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url:"/staff/alls"})
                .then(res => {
                    const today = new Date();

                    // Filter staff where cessadate is null or in the future
                    const activeStaff = res.data.rec.filter(staff => {
                        return !staff.cessadate || new Date(staff.cessadate) > today;
                    });

                    vm.staffFull = activeStaff;

                    for (let i = 0; i < activeStaff.length; i++) {
                        vm.staffDetailsList.push({
                            text: activeStaff[i].psndetails,
                            value: activeStaff[i].id
                        });
                    }

                    if (vm.formData.staffid) {
                        vm.changeStaffIDandCompanyHandler(vm.formData.staffid);
                    }

                    if (vm.formData.ownerstaffid) {
                        vm.changeOwnerStaffIDandCompanyHandler(vm.formData.ownerstaffid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        updateValue() {
            this.$emit('input', {
                roleid: this.formData.roleid,
                staffid: this.formData.staffid,
                ownerstaffid: this.formData.ownerstaffid,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                remarks: this.formData.remarks,
                stamp: this.formData.stamp,
                userid: this.formData.userid,
                workflowrole: this.formData.workflowrole,
                staffno: this.formData.staffno,
                staffcompany: this.formData.staffcompany,
                ownerstaffno: this.formData.ownerstaffno,
                ownerstaffcompany: this.formData.ownerstaffcompany,
            });
        },

        saveHandler() {
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({name: 'roleassignmentlist'});
        }
    },

    mounted() { 
        this.loadWorkflowListHandler();
        this.loadStaffDetailsListHandler();
    },
}
</script>